import styled from 'styled-components'
import { format } from 'date-fns'

import useDateDisplayFormat from 'components/utils/useDateDisplayFormat'
import IconArrowRight from 'components/icons/ArrowRightSlim'

const Wrapper = styled.div`
  width: 100%;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme?.['-ds-neutral-400']?.value};
  background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  display: flex;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  justify-content: space-between;
  align-items: center;

  .date-input {
    flex: 1 1 auto;

    &:last-of-type input {
      text-align: right;
    }
  }

  input {
    width: 100%;
    border: none !important;
    outline: none !important;
    background-color: transparent;
    padding: 0;
    padding: 18px;
  }

  svg {
    width: 20px;
    max-height: 20px;
  }
`

const DateInput = styled.input<{ $disabled?: boolean }>`
  color: ${({ $disabled, theme }) =>
    $disabled
      ? theme?.['-ds-neutral-500']?.value
      : theme?.['-ds-neutral-700']?.value};
`

interface DatesInputProps {
  onDateClick: (type: 'start' | 'end') => any
  startDate: Date
  endDate: Date
}

const DatesInput = ({ onDateClick, startDate, endDate }: DatesInputProps) => {
  const displayFormat = useDateDisplayFormat({ yearFormat: 'YYYY' })

  return (
    <Wrapper>
      <div className="date-input">
        <DateInput
          id="startDate"
          name="startDate"
          aria-label="Start date"
          onClick={() => onDateClick('start')}
          $disabled={!startDate}
          autoComplete="off"
          value={startDate ? format(startDate, displayFormat) : ''}
          placeholder="Start date"
          readOnly
        />
      </div>
      <IconArrowRight />
      <div className="date-input">
        <DateInput
          id="startDate"
          name="endDate"
          aria-label="End date"
          onClick={() => onDateClick('end')}
          $disabled={!endDate}
          readOnly
          autoComplete="off"
          value={endDate ? format(endDate, displayFormat) : ''}
          placeholder="End date"
        />
      </div>
    </Wrapper>
  )
}

export default DatesInput
